// import devtools from '@vue/devtools'
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Article from '@/components/Article'
import EditArticle from '@/components/EditArticle'
import ArticleHistory from '@/components/ArticleHistory'
import AuthComponent from '@mcity/mcity-vue-auth/src/components/AuthComponent.vue'
import { checkRequiresAuth } from '@mcity/mcity-vue-auth/dist/router/beforeEachHooks'

Vue.use(Router)
// Enables auth on routes if VUE_APP_TESTING env var is set to false
const testMode = process.env.VUE_APP_TESTING === 'false' || process.env.VUE_APP_TESTING == null
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        requiresAuth: testMode,
        showEdit: false,
        title: 'Home — Mcity Members'
      },
      beforeEnter: (to, from, next) => {
        next('/wiki/' + process.env.VUE_APP_HOME_URI)
      },
      redirect: '/wiki/' + process.env.VUE_APP_HOME_URI // this is causing the Safari issue. The redirect doesn't carry the Key.
    },
    {
      path: '/search',
      component: () => import('../components/Search'),
      name: 'Search',
      meta: {
        requiresAuth: testMode,
        title: 'Search — Mcity Members'
      }
    },
    {
      path: '/wiki/*/edit',
      component: EditArticle,
      name: 'Article Edit',
      meta: {
        requiresAuth: testMode,
        title: 'Edit Article — Mcity Members',
        page: 'edit'
      },
      props: { isNewArticle: false }
    },
    {
      path: '/wiki/*/new',
      component: EditArticle,
      name: 'New Article',
      meta: {
        requiresAuth: testMode,
        title: 'New Article — Mcity Members',
        page: 'new'
      },
      props: { isNewArticle: true }
    },
    {
      path: '/wiki/*/history',
      component: ArticleHistory,
      name: 'Article History',
      meta: {
        requiresAuth: testMode,
        title: 'Article History — Mcity Members',
        page: 'history'
      },
      beforeEnter: (to, from, next) => {
        store.dispatch('article/transactions/getArticleHistoryAction', to.params.pathMatch)
          .then(() => next())
      }
    },
    {
      path: '/wiki/*',
      component: Article,
      name: 'Article',
      meta: {
        requiresAuth: testMode,
        page: 'article'
      },
      beforeEnter: (to, from, next) => {
        store
          .dispatch('article/transactions/getArticleAction', to.params.pathMatch)
          .then(() => {
            const articleReadRoles = store.state.article.currentArticle.roles.read
            const adminRole = store.state.adminRole
            let found = false
            if (articleReadRoles.length === 0) next() // Allow all.
            else {
              const userRoles = store.state.session.userRoles
              userRoles.forEach(role => {
                if ([...articleReadRoles, adminRole].includes(role)) found = true
              })
              if (found) next()
              else next('/unauthorized')
            }
          })
      }
    },
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: () => import('../components/Denied'),
      meta: {
        requiresAuth: testMode,
        title: 'Unauthorized — Mcity Members'
      }
    },
    {
      path: '/authorized',
      name: 'OverviewAuth',
      components: {
        auth: AuthComponent
      },
      meta: {
        authorized: true,
        title: 'Auth — Mcity Members'
      }
    },
    {
      path: '*',
      name: 'Error',
      component: () => import('@mcity/mcity-vue-shared/components/NotFound'),
      meta: {
        title: 'Not Found — Mcity Members'
      }
    }
  ]
})

router.beforeEach(checkRequiresAuth.bind({ $store: store }))
router.beforeEach((to, from, next) => {
  if (store.state.article.articleHierarchy.length === 0) {
    store.dispatch('article/transactions/getArticlesAction')
  }
  Vue.nextTick(() => {
    document.title = to.meta.title || 'Mcity Members'
  })
  next()
})
export default router
